module.exports = __webpack_public_path__ + "img/avatar7.31862034.png";